(() => {
  if (customElements.get('pickup-availability')) return;

  class PickupAvailability extends HTMLElement {
    constructor() {
      super();

      const template = this.querySelector('template');
      this.errorHtml = template?.content.firstElementChild?.cloneNode(true) || null;
      this.onClickRefreshList = this.onClickRefreshList.bind(this);
      this.requestId = 0;
      this.fetchAvailability(this.dataset.variantId);
    }

    setContainerVisibility(isVisible) {
      this.toggleAttribute('available', isVisible);
      const container = this.closest('.product__pickup-availabilities');
      if (container) container.hidden = !isVisible;
    }

    fetchAvailability(variantId) {
      const requestId = ++this.requestId;

      if (!variantId || !this.dataset.rootUrl) {
        this.removeAttribute('aria-busy');
        this.setContainerVisibility(false);
        return;
      }

      const rootUrl = !this.dataset.rootUrl.endsWith('/')
        ? `${this.dataset.rootUrl}/`
        : this.dataset.rootUrl;

      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;
      this.setAttribute('aria-busy', 'true');
      this.setContainerVisibility(false);

      fetch(variantSectionUrl)
        .then(response => {
          if (!response.ok) throw new Error(`Pickup availability request failed: ${response.status}`);
          return response.text();
        })
        .then(text => {
          if (requestId !== this.requestId) return;

          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          this.renderPreview(sectionInnerHTML);
        })
        .catch(() => {
          if (requestId !== this.requestId) return;

          const button = this.querySelector('button');
          if (button) {
            button.removeEventListener('click', this.onClickRefreshList);
          }

          this.renderError();
        })
        .finally(() => {
          if (requestId === this.requestId) this.removeAttribute('aria-busy');
        });
    }

    onClickRefreshList() {
      this.fetchAvailability(this.dataset.variantId);
    }

    renderError() {
      if (!this.errorHtml) {
        this.setContainerVisibility(false);
        return;
      }

      this.innerHTML = '';
      this.appendChild(this.errorHtml.cloneNode(true));
      const button = this.querySelector('button');
      if (button) button.addEventListener('click', this.onClickRefreshList);
      this.setContainerVisibility(true);
    }

    renderPreview(sectionInnerHTML) {
      const preview = sectionInnerHTML?.querySelector(
        'pickup-availability-preview'
      );

      if (!preview) {
        this.innerHTML = '';
        this.setContainerVisibility(false);
        return;
      }

      this.renderStoreInfoImage(preview);

      this.innerHTML = preview.outerHTML;
      this.setContainerVisibility(true);
    }

    renderStoreInfoImage(preview) {
      if (!this.dataset.storeInfoImage) return;

      const drawerRow = preview.querySelector('.drawer__row');
      if (!drawerRow) return;

      const imageWrapper = document.createElement('div');
      imageWrapper.className = 'pickup-availability-store-image';

      const image = document.createElement('img');
      image.src = this.dataset.storeInfoImage;
      image.alt = this.dataset.storeInfoImageAlt || '';
      image.loading = 'lazy';

      imageWrapper.appendChild(image);
      const title = drawerRow.querySelector('.drawer__title');

      drawerRow.insertBefore(
        imageWrapper,
        title ? title.nextElementSibling : drawerRow.firstChild
      );
    }
  }

  customElements.define('pickup-availability', PickupAvailability);
})();
